module.exports = __webpack_public_path__ + "static/media/bindOutlook2.33d8fc85.png";